import { createContext } from 'react';

// Shared refresh state for every admin dashboard data hook, the
// nonce triggers a refetch and polling only runs on the tv view
export interface AdminRefreshContextValue {
    refreshNonce: number;
    pollingEnabled: boolean;
}

// Default keeps polling off and the nonce stable outside a provider
export const AdminRefreshContext = createContext<AdminRefreshContextValue>({
    refreshNonce: 0,
    pollingEnabled: false,
});
